// red, orange, yellow, green, blue
const BaseLedgerColors = ['#EF4444', '#F97316', '#FACC15', '#22C55E', '#2563EB'] as const

export const getLedgerColor = (index: number): string => {
  if (index < 0) {
    return BaseLedgerColors[0]
  }
  return BaseLedgerColors[index % BaseLedgerColors.length] || ''
}
